const settings = {
  apiUrl: "https://api.nettalkconnect.com",
  apiAuth: "Bearer 3E6E60A59397B158E1FA875AA80D3D641F280986",

  apiNotificationUrl: "https://api.mds.nettalk.com",
  apiNotificationAuth: "b3NjYXJhOnBhc3N3b3JkMUE=",

  pageSizeLoad: 5,
  mobileSize: 880,

  //modules
  moduleCallingCards: "callingcards",
  moduleOmniChannel: "omnichannel",
  modulePbx: "pbx",
  moduleUser: "user",
};

export default settings;
